<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Download
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="py-2"></v-divider>
    <!-- 
    <v-card class="mx-auto w-100 flat padding-form" v-if="selectedType == ''"
      ><p>Please select Export Option to download data.</p></v-card
    > -->

    <v-card class="mx-auto w-100 flat padding-form">
      <div class="">
        <v-col cols="12" sm="3" class="select">
          <v-autocomplete
            v-model="selectedType"
            :items="listData"
            outlined
            dense
            chips
            small-chips
            @change="getClientList"
            @focus="fetchClientList"
            label="Select Data to Export"
          ></v-autocomplete>
        </v-col>
      </div>
      <v-divider v-if="selectedType !== ''" class="p-5"></v-divider>
      <v-row>
        <v-form
          class="padding-form"
          ref="form"
          v-if="selectedType == 'LastMile'"
        >
          <div class="custom-row">
            <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
              <v-autocomplete
                v-model="client_name"
                :items="clients"
                outlined
                dense
                chips
                item-text="name"
                item-value="id"
                small-chips
                label="Client name"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="tracking_number"
                label="Tracking No."
                outlined
                clearable
                @click:clear="clearInput('tracking_number')"
                class="heights"
                height="10px"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="order_reference"
                label="Order Reference"
                outlined
                @click:clear="clearInput('order_reference')"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="selectedStatus"
                :items="allStatus"
                outlined
                item-text="text"
                item-value="value"
                chips
                small-chips
                label="Status"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="rsaStatus"
                :items="rsaStatusArr"
                outlined
                item-text="text"
                item-value="value"
                chips
                small-chips
                label="RSA Event Status"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="origin_country"
                :items="countries"
                outlined
                dense
                item-text="name"
                item-value="id"
                chips
                small-chips
                label="Origin Country"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="destination_country"
                :items="countries"
                outlined
                dense
                item-text="name"
                item-value="id"
                chips
                small-chips
                label="Destination Country"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="serviceType"
                :items="servicesCodes"
                outlined
                dense
                chips
                :item-text="
                  (item) => `${item.service_name} - (${item.service_code})`
                "
                item-value="service_code"
                small-chips
                label="Service Type"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(from_date)"
                    label="From Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    outlined
                    :rules="[
                      (v) => (v && !!v.trim()) || 'From date is required',
                    ]"
                    class="required"
                    @click:clear="clearInput('from_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="from_date"
                  @input="dateMenu = false"
                  :max="getEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenuTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(to_date)"
                    label="To Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    outlined
                    :rules="[(v) => (v && !!v.trim()) || 'To date is required']"
                    class="required"
                    @click:clear="clearInput('to_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="to_date"
                  @input="dateMenuTo = false"
                  :max="getEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="9"
              sm="6"
              class="text-right"
              v-if="
                userCategory.user_category == 3 ||
                userCategory.user_category == 6
              "
            >
              <v-btn
                color="primary"
                @click="searchLastMile"
                :loading="downloader"
                >Download</v-btn
              >
            </v-col>
            <v-col cols="9" sm="9" class="text-right" v-else>
              <v-btn
                color="primary"
                @click="searchLastMile"
                :loading="downloader"
                >Download</v-btn
              >
            </v-col>
          </div>
        </v-form>

        <v-form
          class="padding-form"
          ref="formShipping"
          v-if="selectedType == 'Fulfillment - List of Shipments'"
        >
          <div class="custom-row">
            <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
              <v-autocomplete
                v-model="client_name"
                :items="clients"
                outlined
                dense
                chips
                item-text="name"
                item-value="id"
                small-chips
                label="Client Name"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="order_code"
                label="Order code / Shipping code"
                outlined
                @click:clear="clearInput('order_reference')"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="tracking_number"
                label="Tracking No."
                outlined
                clearable
                @click:clear="clearInput('tracking_number')"
                class="heights"
                height="10px"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="selectedStatus"
                :items="allStatusShipping"
                outlined
                dense
                chips
                small-chips
                label="Shipping Status"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="selected_mode"
                :items="paymodeMode"
                outlined
                dense
                chips
                small-chips
                label="Payment Mode"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="destination_country"
                :items="countries"
                outlined
                dense
                item-text="name"
                item-value="code"
                chips
                small-chips
                label="Destination Country"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(from_date)"
                    label="From Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    clearable
                    :rules="[
                      (v) => (v && !!v.trim()) || 'From date is required',
                    ]"
                    class="required"
                    @click:clear="clearInput('from_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="from_date"
                  @input="dateMenu = false"
                  :max="getEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenuTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(to_date)"
                    label="To Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    :rules="[(v) => (v && !!v.trim()) || 'To date is required']"
                    class="required"
                    clearable
                    @click:clear="clearInput('to_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="to_date"
                  @input="dateMenuTo = false"
                  :max="getEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              class="text-right"
              :sm="userCategory.user_category == 1 ? '3' : '12'"
            >
              <v-btn
                color="primary"
                @click="searchShipping"
                :loading="downloader"
                >Download</v-btn
              >
              <!-- <v-btn color="primary" class="mt-4 ml-4" @click="clearAll"
                  >Clear</v-btn
                > -->
            </v-col>
          </div>
        </v-form>
        <v-form
          class="padding-form"
          ref="formFulfilment"
          v-if="selectedType == 'Fulfillment Order List with Items'"
        >
          <div class="custom-row">
            <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
              <v-autocomplete
                v-model="client_name"
                :items="clients"
                outlined
                dense
                chips
                item-text="name"
                item-value="id"
                small-chips
                label="Client name"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="order_code"
                label="Sale order code"
                outlined
                @click:clear="clearInput('order_reference')"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="sku"
                label="Sku"
                outlined
                clearable
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="selectedStatus"
                :items="statuses"
                outlined
                dense
                chips
                small-chips
                label="Order Status"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="selected_mode"
                :items="paymodeMode"
                outlined
                dense
                chips
                small-chips
                label="Payment Mode"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(from_date)"
                    label="From Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    clearable
                    :rules="[
                      (v) => (v && !!v.trim()) || 'From date is required',
                    ]"
                    class="required"
                    @click:clear="clearInput('from_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="from_date"
                  @input="dateMenu = false"
                  :max="getEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenuTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(to_date)"
                    label="To Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    :rules="[(v) => (v && !!v.trim()) || 'To date is required']"
                    class="required"
                    clearable
                    @click:clear="clearInput('to_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="to_date"
                  @input="dateMenuTo = false"
                  :max="getEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              class="text-right"
              :sm="userCategory.user_category == 1 ? '6' : '3'"
            >
              <v-btn
                color="primary"
                @click="searchFulfilement"
                :loading="downloader"
                >Download</v-btn
              >
              <!-- <v-btn color="primary" class="mt-4 ml-4" @click="clearAll"
                  >Clear</v-btn
                > -->
            </v-col>
          </div>
        </v-form>

        <v-form
          class="padding-form"
          ref="formOrder"
          v-if="selectedType == 'Fulfillment Order list'"
        >
          <div class="custom-row">
            <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
              <v-autocomplete
                v-model="client_name"
                :items="clients"
                outlined
                dense
                chips
                item-text="name"
                item-value="id"
                small-chips
                label="Client name"
                @input="getDropdown(clients)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="order_code"
                label="Order code"
                outlined
                @click:clear="clearInput('order_reference')"
                clearable
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="selectedStatus"
                :items="statuses"
                outlined
                dense
                chips
                small-chips
                label="Order Status"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select
                v-model="channel"
                label="Channel"
                :items="channelList"
                item-text="channel_name"
                item-value="channel_code"
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="selected_mode"
                :items="paymodeMode"
                outlined
                dense
                chips
                small-chips
                label="Payment Mode"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="destination_country"
                :items="countries"
                outlined
                dense
                item-text="name"
                item-value="code"
                chips
                small-chips
                label="Destination Country"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(from_date)"
                    label="From Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    clearable
                    :rules="[
                      (v) => (v && !!v.trim()) || 'From date is required',
                    ]"
                    class="required"
                    @click:clear="clearInput('from_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="from_date"
                  @input="dateMenu = false"
                  :max="getEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenuTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(to_date)"
                    label="To Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    :rules="[(v) => (v && !!v.trim()) || 'To date is required']"
                    class="required"
                    clearable
                    @click:clear="clearInput('to_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="to_date"
                  @input="dateMenuTo = false"
                  :max="getEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              class="text-right"
              :sm="userCategory.user_category == 1 ? '3' : '12'"
            >
              <v-btn color="primary" @click="searchOrders" :loading="downloader"
                >Download</v-btn
              >
              <!-- <v-btn color="primary" class="mt-4 ml-4" @click="clearAll"
                  >Clear</v-btn
                > -->
            </v-col>
          </div>
        </v-form>
      </v-row>
      <v-form
        class="padding-pre"
        ref="formTracking"
        v-if="selectedType == 'Lastmile Tracking Details'"
      >
        <div class="custom-row">
          <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
            <v-autocomplete
              v-model="client_name"
              :items="clients"
              outlined
              dense
              chips
              item-text="name"
              item-value="id"
              small-chips
              label="Client name"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              v-model="origin_country"
              :items="countries"
              outlined
              dense
              item-text="name"
              item-value="id"
              chips
              small-chips
              label="Origin Country"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              v-model="destination_country"
              :items="countries"
              outlined
              dense
              item-text="name"
              item-value="id"
              chips
              small-chips
              label="Destination Country"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(from_date)"
                  label="From Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  clearable
                  :rules="[(v) => (v && !!v.trim()) || 'From date is required']"
                  class="required"
                  @click:clear="clearInput('from_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="from_date"
                @input="dateMenu = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenuTo"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(to_date)"
                  label="To Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :rules="[(v) => (v && !!v.trim()) || 'To date is required']"
                  class="required"
                  clearable
                  @click:clear="clearInput('to_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="to_date"
                @input="dateMenuTo = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            class="text-right"
            :sm="userCategory.user_category == 1 ? '6' : '9'"
          >
            <v-btn
              color="primary"
              @click="searchLastmiletracking"
              :loading="downloader"
              >Download</v-btn
            >
          </v-col>
        </div>
      </v-form>
      <v-form
        class="padding-pre"
        ref="preAlert"
        v-if="selectedType == 'Lastmile Pre Alert Shipment'"
      >
        <div class="custom-row">
          <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
            <v-autocomplete
              v-model="client_name"
              :items="clients"
              outlined
              dense
              chips
              item-text="name"
              item-value="id"
              small-chips
              label="Client name"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(from_date)"
                  label="From Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  clearable
                  :rules="[(v) => (v && !!v.trim()) || 'From date is required']"
                  class="required"
                  @click:clear="clearInput('from_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="from_date"
                @input="dateMenu = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenuTo"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(to_date)"
                  label="To Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :rules="[(v) => (v && !!v.trim()) || 'To date is required']"
                  class="required"
                  clearable
                  @click:clear="clearInput('to_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="to_date"
                @input="dateMenuTo = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            class="text-right"
            :sm="userCategory.user_category == 1 ? '6' : '3'"
          >
            <v-btn color="primary" @click="searchPreAlert" :loading="downloader"
              >Download</v-btn
            >
          </v-col>
        </div>
      </v-form>
      <v-form
        class="padding-pre"
        ref="hawb"
        v-if="selectedType == 'Lastmile Pre Alert Shipment hawb'"
      >
        <div class="custom-row">
          <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
            <v-autocomplete
              v-model="client_name"
              :items="clients"
              outlined
              dense
              chips
              item-text="name"
              item-value="id"
              small-chips
              label="Client name"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(from_date)"
                  label="From Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  clearable
                  :rules="[(v) => (v && !!v.trim()) || 'From date is required']"
                  class="required"
                  @click:clear="clearInput('from_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="from_date"
                @input="dateMenu = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenuTo"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(to_date)"
                  label="To Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :rules="[(v) => (v && !!v.trim()) || 'To date is required']"
                  class="required"
                  clearable
                  @click:clear="clearInput('to_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="to_date"
                @input="dateMenuTo = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            class="text-right"
            :sm="userCategory.user_category == 1 ? '6' : '3'"
          >
            <v-btn color="primary" @click="hawbsearch" :loading="downloader"
              >Download</v-btn
            >
          </v-col>
        </div>
      </v-form>

      <!-- b2b form start -->

      <v-form
        class="padding-pre"
        ref="b2b"
        v-if="selectedType == 'B2B SKU Variant'"
      >
        <div class="custom-row">
          <v-col
            cols="12"
            sm="3"
            v-if="
              userCategory.user_category === 3 ||
              userCategory.user_category === 6
            "
          >
            <v-autocomplete
              v-model="client_name"
              :items="clients"
              outlined
              dense
              chips
              item-text="name"
              item-value="id"
              small-chips
              label="Client name"
              @change="clearB2BInput"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              v-model="sku_code"
              outlined
              label="SKU Code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="sku_variant_code"
              label="SKU Variant/Barcode Code"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(from_date)"
                  label="From Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  clearable
                  :rules="[(v) => (v && !!v.trim()) || 'From date is required']"
                  class="required"
                  @click:clear="clearInput('from_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="from_date"
                @input="dateMenu = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenuTo"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(to_date)"
                  label="To Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :rules="[(v) => (v && !!v.trim()) || 'To date is required']"
                  class="required"
                  clearable
                  @click:clear="clearInput('to_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="to_date"
                @input="dateMenuTo = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              v-model="sku_type"
              :items="typesSku"
              item-text="text"
              item-value="value"
              label="Sku Type"
              class="pb-0"
              outlined
            ></v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            class="text-right"
            :sm="userCategory.user_category == 1 ? '9' : '6'"
          >
            <v-btn color="primary" @click="searchB2B" :loading="downloader"
              >Download</v-btn
            >
          </v-col>
        </div>
      </v-form>
      <!-- b2b form end -->

      <!-- pas form start  -->
      <v-form class="padding-pre" ref="pas" v-if="selectedType == 'PAS'">
        <div class="custom-row">
          <v-col cols="12" sm="3">
            <v-text-field
              label="Token Number"
              v-model="token_number"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              :items="purposes"
              outlined
              v-model="purpose"
              dense
              chips
              small-chips
              label="Purpose"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              :items="eventStatus"
              outlined
              v-model="latest_event_status"
              dense
              chips
              small-chips
              label="Event status"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              :items="storers"
              outlined
              v-model="storer_id"
              dense
              chips
              small-chips
              label="Storer"
              item-text="storer_name"
              item-value="id"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              :items="statusesPAS"
              outlined
              v-model="active"
              dense
              chips
              small-chips
              label="Status"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              :items="warehousees"
              outlined
              v-model="wms_warehouse_code"
              dense
              chips
              small-chips
              label="Warehouse"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              :items="vehicles"
              outlined
              v-model="vehicle_type"
              dense
              chips
              small-chips
              label="Type of vehicle"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(from_date)"
                  label="From Date"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  readonly
                  clearable
                  :rules="[(v) => !!v || 'From date is required']"
                  class="required"
                  @click:clear="clearInput('from_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="from_date"
                @input="dateMenu = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenuTo"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(to_date)"
                  label="To Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :rules="[(v) => !!v || 'To date is required']"
                  class="required"
                  clearable
                  @click:clear="clearInput('to_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="to_date"
                @input="dateMenuTo = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            class="text-right"
            :sm="userCategory.user_category == 1 ? '9' : '9'"
          >
            <v-btn color="primary" @click="downloadPas" :loading="downloader"
              >Download</v-btn
            >
          </v-col>
        </div>
      </v-form>

      <!-- pas form end  -->

      <!-- ibound form start -->

      <v-form
        class="padding-pre"
        ref="inbound"
        v-if="selectedType == 'B2B Inbound Download'"
      >
        <div class="custom-row">
          <v-col
            cols="12"
            sm="3"
            v-if="
              userCategory.user_category === 3 ||
              userCategory.user_category === 6
            "
          >
            <v-autocomplete
              v-model="selectedClient"
              :items="clientsOut"
              :loading="clientLoader"
              hide-no-data
              item-text="name"
              item-value="id"
              label="Select Client"
              placeholder="Start typing to Search"
              class="pb-2 pt-0 text-center"
              @focus="fetchClientListOutbound"
              @change="getwarehouse(selectedClient)"
              outlined
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pb-0">
            <v-autocomplete
              v-model="warehouse_id"
              label="Warehouse"
              item-text="name"
              item-value="id"
              :items="warehouses"
              outlined
              @change="getStores(selectedClient, warehouse_id)"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pb-0" v-if="selectedClient">
            <v-autocomplete
              v-model="infor_storer_id"
              label="Storer Name"
              item-text="channel_name"
              item-value="id"
              :items="stores"
              outlined
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              label="Receipt key"
              outlined
              v-model="receipt_key"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="External Receipt"
              outlined
              v-model="receipt_no"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              v-model="status"
              :items="statusesinbound"
              hide-no-data
              item-text="name"
              item-value="id"
              label="Status"
              placeholder="Start typing to Search"
              class="pb-2 pt-0 text-center"
              @focus="fetchStatusInbound('inbound')"
              outlined
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(from_date)"
                  label="From Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  clearable
                  :rules="[(v) => (v && !!v.trim()) || 'From date is required']"
                  class="required"
                  @click:clear="clearInput('from_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="from_date"
                @input="dateMenu = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenuTo"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(to_date)"
                  label="To Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :rules="[(v) => (v && !!v.trim()) || 'To date is required']"
                  class="required"
                  clearable
                  @click:clear="clearInput('to_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="to_date"
                @input="dateMenuTo = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            sm="3"
            class="text-right"
            :class="
              userCategory.user_category == 1 && selectedClient
                ? ''
                : (userCategory.user_category == 3 ||
                    userCategory.user_category == 6) &&
                  selectedClient
                ? 'offset-md-9'
                : ''
            "
          >
            <v-btn
              color="primary"
              @click="downloadInbound"
              :loading="downloader"
              >Download</v-btn
            >
          </v-col>
        </div>
      </v-form>

      <!-- inbound form end -->

      <!-- outbound form start -->

      <v-form
        class="padding-pre"
        ref="outbound"
        v-if="selectedType == 'B2B Outbound Download'"
      >
        <div class="custom-row">
          <v-col
            cols="12"
            sm="3"
            v-if="
              userCategory.user_category === 3 ||
              userCategory.user_category === 6
            "
          >
            <v-autocomplete
              v-model="selectedClient"
              :items="clientsOut"
              :loading="clientLoader"
              hide-no-data
              item-text="name"
              item-value="id"
              label="Select Client"
              placeholder="Start typing to Search"
              class="pb-2 pt-0 text-center"
              @focus="fetchClientListOutbound"
              @change="getwarehouse(selectedClient)"
              outlined
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pb-0">
            <v-autocomplete
              v-model="warehouse_id"
              label="Warehouse"
              item-text="name"
              item-value="id"
              :items="warehouses"
              outlined
              @change="getStores(selectedClient, warehouse_id)"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pb-0" v-if="selectedClient">
            <v-autocomplete
              v-model="infor_storer_id"
              label="Storer Name"
              item-text="channel_name"
              item-value="id"
              :items="stores"
              outlined
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              label="Order Number"
              outlined
              v-model="order_key"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              label="External Number"
              outlined
              v-model="receipt_no"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              v-model="status"
              :items="statusesoutbound"
              hide-no-data
              item-text="name"
              item-value="id"
              label="Status"
              placeholder="Start typing to Search"
              class="pb-2 pt-0 text-center"
              @focus="fetchStatus('outbound')"
              outlined
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(from_date)"
                  label="From Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  clearable
                  :rules="[(v) => (v && !!v.trim()) || 'From date is required']"
                  class="required"
                  @click:clear="clearInput('from_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="from_date"
                @input="dateMenu = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenuTo"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(to_date)"
                  label="To Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :rules="[(v) => (v && !!v.trim()) || 'To date is required']"
                  class="required"
                  clearable
                  @click:clear="clearInput('to_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="to_date"
                @input="dateMenuTo = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            class="text-right"
            sm="3"
            :class="
              userCategory.user_category == 1 && selectedClient
                ? ''
                : (userCategory.user_category == 6 ||
                    userCategory.user_category == 3) &&
                  selectedClient
                ? 'offset-md-9'
                : ''
            "
          >
            <v-btn
              color="primary"
              @click="downloadOutbound"
              :loading="downloader"
              >Download</v-btn
            >
          </v-col>
        </div>
      </v-form>

      <!-- outbound form end -->

      <v-form
        class="padding-pre"
        ref="putaway"
        v-if="selectedType == 'Careem Putaway Transaction'"
      >
        <div class="custom-row">
          <v-col cols="12" sm="3" md="3" class="pb-0">
            <v-autocomplete
              v-model="warehouse_id"
              label="Warehouse"
              item-text="name"
              item-value="id"
              :items="warehousesPutaway"
              outlined
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              label="Receipt Key"
              outlined
              v-model="receipt_key"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              label="External Receipt Number"
              outlined
              v-model="external_receipt_number"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(from_date)"
                  label="From Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  clearable
                  :rules="[(v) => (v && !!v.trim()) || 'From date is required']"
                  class="required"
                  @click:clear="clearInput('from_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="from_date"
                @input="dateMenu = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenuTo"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(to_date)"
                  label="To Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :rules="[(v) => (v && !!v.trim()) || 'To date is required']"
                  class="required"
                  clearable
                  @click:clear="clearInput('to_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="to_date"
                @input="dateMenuTo = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" class="text-right" sm="9">
            <v-btn
              color="primary"
              @click="downloadPutaway"
              :loading="downloader"
              >Download</v-btn
            >
          </v-col>
        </div>
      </v-form>

      <v-form class="padding-pre" ref="sla" v-if="selectedType == 'SLA Report'">
        <div class="custom-row">
          <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
            <v-autocomplete
              v-model="client_name"
              :items="clients"
              outlined
              dense
              chips
              item-text="name"
              item-value="id"
              small-chips
              label="Client Name"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              :items="activeCarriersListTypes"
              outlined
              v-model="carrier_id"
              dense
              chips
              item-text="name"
              item-value="id"
              small-chips
              label="Carrier Name"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="Tracking Number"
              outlined
              v-model="tracking_number_sla"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="Order Reference"
              outlined
              v-model="order_reference_sla"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(from_date)"
                  label="From Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  clearable
                  :rules="[(v) => (v && !!v.trim()) || 'From date is required']"
                  class="required"
                  @click:clear="clearInput('from_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="from_date"
                @input="dateMenu = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="dateMenuTo"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="getFormattedDate(to_date)"
                  label="To Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :rules="[(v) => (v && !!v.trim()) || 'To date is required']"
                  class="required"
                  clearable
                  @click:clear="clearInput('to_date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="to_date"
                @input="dateMenuTo = false"
                :max="getEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="3">
            <v-autocomplete
              :items="slaStatuses"
              outlined
              v-model="sla_status"
              dense
              chips
              small-chips
              label="Status"
            ></v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            class="text-right"
            :sm="userCategory.user_category == 1 ? '6' : '3'"
          >
            <v-btn color="primary" @click="downloadSla" :loading="downloader"
              >Download</v-btn
            >
          </v-col>
        </div>
      </v-form>
    </v-card>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      sku_type: null,
      typesSku: [
        { text: "Generate a Variant", value: 0 },
        { text: "Add an existing Barcode", value: 1 },
      ],

      warehousesPutaway: [],
      infor_storer_id: null,
      clientsOut: [],
      statusesoutbound: [],
      token_number: null,
      purpose: null,
      vehicle_type: null,
      wms_warehouse_code: null,
      storer_id: null,
      warehouse_id: null,
      warehouses: [],
      purposes: [
        {
          text: "Inbound",
          value: 1,
        },
        {
          text: "Outbound",
          value: 2,
        },
        {
          text: "Both",
          value: 3,
        },
      ],
      statusesPAS: [
        {
          text: "In Progress",
          value: 1,
        },
        {
          text: "Completed",
          value: 2,
        },
        {
          text: "Force Closed",
          value: 3,
        },
      ],
      eventStatus: [
        {
          text: "Vehicle Report In",
          value: "VEHICLE_REPORT_IN",
        },
        {
          text: "Driver Declaration",
          value: "DRIVER_DECLARATION",
        },
        {
          text: "Security - Gate In",
          value: "SECURITY_GATE_IN",
        },
        {
          text: "Warehouse - Doc In",
          value: "WAREHOUSE_DOCK_IN",
        },
        {
          text: "Warehouse - Doc Out",
          value: "WAREHOUSE_DOCK_OUT",
        },
        {
          text: "Security - Gate Out",
          value: "SECURITY_GATE_OUT",
        },
        {
          text: "Force - Closed",
          value: "FORCE_CLOSED",
        },
      ],
      latest_event_status: null,
      b2b: false,
      sku_variant_code: null,
      sku_code: null,
      serviceType: null,
      hawb: false,
      lastmileTracking: false,
      preAlertshipment: false,
      downloader: false,
      selectedClient: "",
      errorMessage: false,
      clients: [],
      allStatus: [],
      search: "",
      selectedType: "",
      listData: [],
      to_date: "",
      from_date: "",
      tracking_number: "",
      order_reference: "",
      lastMile: false,
      shipping: false,
      countries: [],
      destination_country: "",
      origin_country: "",
      client_name: "",
      dateMenuTo: false,
      order_code: "",
      paymodeMode: [],
      selectedStatus: "",
      dateMenu: false,
      selected_mode: "",
      allStatusShipping: [],
      rsaStatus: "",
      rsaStatusArr: [],
      statusesinbound: [],
      orderList: false,
      channelList: [],
      channel: null,
      servicesCodes: [],
      order_key: "",
      receipt_no: "",
      status: null,
      stores: [],
      statuses: [
        {
          text: "PROCESSING",
          value: "PROCESSING",
        },
        {
          text: "CREATED",
          value: "CREATED",
        },
        {
          text: "CANCELLED",
          value: "CANCELLED",
        },
        {
          text: "COMPLETE",
          value: "COMPLETE",
        },
        {
          text: "UNFULFILLABLE",
          value: "UNFULFILLABLE",
        },
        {
          text: "PARTALLY UNFULFILLABLE",
          value: "PARTALLY_UNFULFILLABLE",
        },
      ],
      slaStatuses: [
        {
          text: "No SLA",
          value: -1,
        },
        {
          text: "No SLA",
          value: -1,
        },
        {
          text: "Not Started",
          value: 0,
        },
        {
          text: "No SLA",
          value: -1,
        },
        {
          text: "In Transit",
          value: 1,
        },
        {
          text: "Maybe Delayed",
          value: 2,
        },
        {
          text: "Delivery Delayed",
          value: 3,
        },
        {
          text: "On Time Delivered",
          value: 4,
        },
      ],
      sla_status: null,
      activeCarriersListTypes: [],
      carrier_id: null,
      order_reference_sla: null,
      tracking_number_sla: null,
    };
  },
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  async mounted() {
    this.$nextTick(() => {
      this.getCountryList();
    });
  },

  methods: {
    ...mapActions([
      "getRSAreportlist",
      "getCountries",
      "lastMileReport",
      "shippingReport",
      "lastmileStatus",
      "shippingStatus",
      "snackBar",
      "fetchClient",
      "shippingFulfillmentReport",
      "ordersReport",
      "getChannelDropdown",
      "trackingReport",
      "preAlertReport",
      "hawbReport",
      "getRSAServiceListOnly",
      "b2bReport",
      "downloadPasData",
      "inboundReport",
      "outboundReport",
      "fetchStorelist",
      "inboundStatus",
      "getChannelDropdown",
      "getChannelDropdownReport",
      "getInforWarehouseListBB",
      "getWarehouseStores",
      "getInforWarehouseList",
      "putawayreport",
      "getCarriersDropdown",
      "slaReport",
    ]),
    async fetchCarriers() {
      if (this.activeCarriersListTypes.length) return;
      await this.getCarriersDropdown({
        pagination: 0,
        active: "all",
      })
        .then((res) => {
          this.activeCarriersListTypes = res.data.filter(
            (carrier) => carrier.active === true
          );
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getwarehouse(id) {
      if (id !== null && id !== undefined && id !== "") {
        this.warehouse = "";
        (this.warehouse_id = null), (this.receipt_key = null);
        this.order_key = null;
        this.receipt_no = null;
        this.status = null;
        this.from_date = null;
        this.to_date = null;
        this.infor_storer_id = null;
        this.getInforWarehouseListBB(id).then((response) => {
          this.warehouses = response.data.result;
        });
      } else {
        this.warehouses = [];
        this.warehouse_id = null;
        this.receipt_key = null;
      }
    },
    getStores() {
      if (this.selectedClient && this.warehouse_id) {
        let payload = {
          client_id: this.selectedClient,
          warehouse_id: this.warehouse_id,
        };

        this.getWarehouseStores(payload).then((res) => {
          this.stores = res.data;
        });
      }
    },

    fetchClientListOutbound() {
      if (this.clientsOut.length) return;

      if (
        this.clientsOut.length === 0 &&
        (this.userCategory.user_category === 3 ||
          this.userCategory.user_category === 6)
      ) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clientsOut = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    fetchStatusInbound(type) {
      if (this.statusesinbound.length == 0)
        this.inboundStatus(type).then((res) => {
          let statusArr = Object.entries(res.data.data).map(([key, value]) => {
            return { id: key, name: value };
          });
          this.statusesinbound = statusArr;
        });
    },
    fetchStatus(type) {
      if (this.statusesoutbound.length == 0)
        this.inboundStatus(type).then((res) => {
          let statusArr = Object.entries(res.data.data).map(([key, value]) => {
            return { id: key, name: value };
          });
          this.statusesoutbound = statusArr;
        });
    },
    fetchStore() {
      this.fetchStorelist().then((res) => {
        this.storers = res.data.storer;
        this.warehousees = res.data.warehouses.map(
          (obj) => Object.keys(obj)[0]
        );
        this.vehicles = res.data.vehicle_types;
      });
    },
    getDropdown() {
      if (this.client_name)
        this.getChannelDropdown(this.client_name).then((res) => {
          this.channelList = res.data;
        });
    },
    getClientList() {
      if (
        this.userCategory.user_category === 3 ||
        this.userCategory.user_category === 6
      ) {
        let service = "";

        if (
          this.selectedType == "LastMile" ||
          this.selectedType == "Lastmile Tracking Details" ||
          this.selectedType == "Lastmile Pre Alert Shipment" ||
          this.selectedType == "Lastmile Pre Alert Shipment hawb" ||
          this.selectedType == "SLA Report"
        ) {
          service = "clickdna,fulfillment_wid_last_mile";
        } else if (this.selectedType == "B2B SKU Variant") {
          service = "b2b_fulfillment";
        } else {
          service = "fulfillment_wid_last_mile,fulfillment";
        }
        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: service,
        }).then((res) => {
          this.clients = res.data;
        });
      }
      if (this.$store.getters.user.user_category == 1) {
        if (this.selectedType == "Fulfillment Order list")
          this.getChannelDropdown(this.$store.getters.user.id).then((res) => {
            this.channelList = res.data;
          });
      }
      this.clear();
    },
    getShippngStatus() {
      this.shippingStatus().then((response) => {
        let val = response.data.shipment_status;
        let payment_mode = response.data.payment_mode;
        for (let x in val) {
          let obj = {
            text: val[x],
            value: x,
          };
          this.allStatusShipping.push(obj);
        }
        for (let pay in payment_mode) {
          this.paymodeMode.push(pay);
        }
      });
    },
    getStatus() {
      this.lastmileStatus().then((response) => {
        let val = response.data.movement_request_status;
        var rsa = response.data.rsa_event_list;

        for (let x in val) {
          let obj = {
            text: val[x],
            value: x,
          };
          this.allStatus.push(obj);
        }
        for (let z in rsa) {
          let obj = {
            text: rsa[z],
            value: z,
          };
          this.rsaStatusArr.push(obj);
        }
      });
    },

    fetchClientList() {
      if (
        this.userCategory.access_rights !== undefined &&
        this.userCategory.access_rights !== "" &&
        this.userCategory.access_rights !== null
      ) {
        this.userCategory.access_rights.permission_key.findIndex((e) => {
          if (e == "app_report_export:er-last-mile") {
            this.lastMile = true;

            if (this.servicesCodes.length == 0) {
              this.getRSAServiceListOnly().then((res) => {
                this.servicesCodes = res.data;
              });
            }
            this.listData.push("LastMile");
            this.getStatus();
          }
          if (e == "app_report_export:er-shipping") {
            this.shipping = true;
            this.listData.push("Fulfillment - List of Shipments");
            this.getShippngStatus();
          }
          if (e == "app_report_export:er-order-sku") {
            this.shippingSku = true;
            this.listData.push("Fulfillment Order List with Items");
          }
          if (e == "app_report_export:er-orderlist") {
            this.orderList = true;
            this.listData.push("Fulfillment Order list");
          }
          if (e == "app_report_export:er-last-mile-tracking-details") {
            this.lastmileTracking = true;
            this.listData.push("Lastmile Tracking Details");
          }
          if (e == "app_report_export:prealert-shipments") {
            this.preAlertshipment = true;
            this.listData.push("Lastmile Pre Alert Shipment");
          }
          if (e == "app_report_export:prealert-shipment-hawbs") {
            this.hawb = true;
            this.listData.push("Lastmile Pre Alert Shipment hawb");
          }
          if (e == "app_report_export:btb-sku-variant-download-report") {
            this.b2b = true;
            this.listData.push("B2B SKU Variant");
          }

          if (e == "app_pas:excel_download_gate_tokens") {
            this.listData.push("PAS");
            this.fetchStore();
          }
          if (e == "app_report_export:b2b-inbound-download") {
            this.fetchStatus("inbound");
            this.listData.push("B2B Inbound Download");
            if (this.$store.getters.user.user_category == 1) {
              this.selectedClient = this.$store.getters.user.id;
              this.getChannelDropdown(this.$store.getters.user.id).then(
                (res) => {
                  this.stores = res.data;
                }
              );
            }
          }
          if (e == "app_report_export:b2b-outbound-download") {
            this.listData.push("B2B Outbound Download");
            this.fetchStatus("outbound");
            if (this.$store.getters.user.user_category == 1) {
              this.selectedClient = this.$store.getters.user.id;
              this.getChannelDropdown(this.$store.getters.user.id).then(
                (res) => {
                  this.stores = res.data;
                }
              );
            }
          }
          if (e == "app_report_export:inbound-putaway-transaction-report") {
            this.listData.push("Careem Putaway Transaction");

            this.getInforWarehouseList().then((response) => {
              this.warehousesPutaway = response.data.result;
            });
          }
          if (e == "app_report_export:sla-tracker") {
            this.listData.push("SLA Report");
            this.fetchCarriers();
          }
        });
      }
    },
    getCountryList() {
      this.getCountries().then((res) => {
        this.countries = res.data;
      });
    },
    dateDifference(days) {
      this.errorMessage = "";
      if (this.from_date !== "" || this.to_date !== "") {
        if (this.from_date && this.to_date) {
          const targetDate = new Date(this.to_date);
          const currentDate = new Date(this.from_date);
          const differenceMs = targetDate.getTime() - currentDate.getTime();
          const differenceDays = Math.ceil(
            differenceMs / (1000 * 60 * 60 * 24)
          );
          if (days == 92) {
            if (differenceDays >= 92) {
              this.snackBar({
                color: "error",
                message: "Please choose a date range of up to 92 days.",
              });
              this.errorMessage = "founder error";
              this.downloader = false;
            }
          } else {
            if (differenceDays >= 31) {
              this.snackBar({
                color: "error",
                message: "Please choose a date range of up to 31 days.",
              });
              this.errorMessage = "founder error";
              this.downloader = false;
            }
          }
        }
      }
    },
    clear() {
      this.from_date = null;
      this.to_date = null;
      this.client_name = null;
      this.selected_mode = null;
      this.selectedStatus = null;
      this.order_code = null;
      this.sku = null;
      (this.order_reference = null),
        (this.tracking_number = null),
        (this.destination_country = null),
        (this.origin_country = null),
        (this.rsaStatus = null);
      this.selectedClient = "";
      this.receipt_key = "";
      this.receipt_no = "";
      this.status = "";
      this.infor_storer_id = "";
      this.warehouse_id = "";
      this.order_key = "";
      // clear all values
    },
    hawbsearch() {
      if (!this.$refs.hawb.validate()) return;
      this.downloader = true;
      this.dateDifference();
      if (this.errorMessage == "") {
        let obj = {
          start_date: this.from_date,
          end_date: this.to_date,
          client_id: this.client_name,
        };

        Object.keys(obj).forEach((key) => {
          if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
            delete obj[key];
          }
        });
        this.filtersArr = obj;
        this.hawbReport(obj)
          .then((res) => {
            this.fileDownload(res);
            this.snackBar({
              color: "success",
              message: "Data downloaded successfully",
            });
            this.downloader = false;
          })
          .catch(() => {
            this.downloader = false;
          });
      }
    },
    searchPreAlert() {
      if (!this.$refs.preAlert.validate()) return;
      this.downloader = true;
      this.dateDifference();
      if (this.errorMessage == "") {
        let obj = {
          start_date: this.from_date,
          end_date: this.to_date,
          client_id: this.client_name,
        };

        Object.keys(obj).forEach((key) => {
          if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
            delete obj[key];
          }
        });
        this.filtersArr = obj;
        this.preAlertReport(obj)
          .then((res) => {
            this.fileDownload(res);
            this.snackBar({
              color: "success",
              message: "Data downloaded successfully",
            });
            this.downloader = false;
          })
          .catch(() => {
            this.downloader = false;
          });
      }
    },
    searchLastMile() {
      if (!this.$refs.form.validate()) return;
      this.downloader = true;
      this.dateDifference();
      if (this.errorMessage == "") {
        let obj = {
          start_date: this.from_date,
          end_date: this.to_date,
          client_id: this.client_name,
          order_reference: this.order_reference,
          tracking_no: this.tracking_number,
          movement_request_status: this.selectedStatus,
          destination_country: this.destination_country,
          origin_country: this.origin_country,
          rsa_event_id: this.rsaStatus,
          service_type: this.serviceType,
        };

        Object.keys(obj).forEach((key) => {
          if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
            delete obj[key];
          }
        });
        this.filtersArr = obj;
        this.lastMileReport(obj)
          .then((res) => {
            this.fileDownload(res);
            this.snackBar({
              color: "success",
              message: "Data downloaded successfully",
            });
            this.downloader = false;
          })
          .catch(() => {
            this.downloader = false;
          });
      }
    },
    downloadPas() {
      if (!this.$refs.pas.validate()) return;
      this.downloader = true;
      this.dateDifference();
      if (this.errorMessage == "") {
        let obj = {
          token_number: this.token_number,
          purpose: this.purpose,
          storer_id: this.storer_id,
          active: this.active,
          latest_event_status: this.latest_event_status,
          to_date: this.to_date,
          from_date: this.from_date,
          wms_warehouse_code: this.wms_warehouse_code,
          vehicle_type: this.vehicle_type,
        };

        Object.keys(obj).forEach((key) => {
          if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
            delete obj[key];
          }
        });
        this.downloadPasData(obj)
          .then((res) => {
            this.fileDownload(res);
            this.snackBar({
              color: "success",
              message: "Data downloaded successfully",
            });
            this.downloader = false;
          })
          .catch(() => {
            this.downloader = false;
          });
      }
    },
    searchShipping() {
      if (!this.$refs.formShipping.validate()) return;
      this.downloader = true;
      this.dateDifference();
      if (this.destination_country) {
        this.destination_country = this.destination_country.toUpperCase();
      }
      if (this.errorMessage == "") {
        let obj = {
          start_date: this.from_date,
          end_date: this.to_date,
          client_id: this.client_name,
          tracking_number: this.tracking_number,
          payment_mode: this.selected_mode,
          shipping_status: this.selectedStatus,
          destination_country: this.destination_country,
          shipping_package_code: this.order_code,
        };

        Object.keys(obj).forEach((key) => {
          if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
            delete obj[key];
          }
        });
        this.filtersArr = obj;
        this.shippingReport(obj)
          .then((res) => {
            this.fileDownload(res);
            this.snackBar({
              color: "success",
              message: "Data downloaded successfully",
            });
            this.downloader = false;
          })
          .catch(() => {
            this.downloader = false;
          });
      }
    },
    searchFulfilement() {
      if (!this.$refs.formFulfilment.validate()) return;
      this.downloader = true;
      this.dateDifference();
      if (this.errorMessage == "") {
        let obj = {
          start_date: this.from_date,
          end_date: this.to_date,
          client_id: this.client_name,
          payment_mode: this.selected_mode,
          sale_order_details_status: this.selectedStatus,
          sale_order_code: this.order_code,
          sku: this.sku,
        };

        Object.keys(obj).forEach((key) => {
          if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
            delete obj[key];
          }
        });
        this.filtersArr = obj;
        this.shippingFulfillmentReport(obj)
          .then((res) => {
            this.fileDownload(res);
            this.snackBar({
              color: "success",
              message: "Data downloaded successfully",
            });
            this.downloader = false;
          })
          .catch(() => {
            this.downloader = false;
          });
      }
    },
    searchLastmiletracking() {
      if (!this.$refs.formTracking.validate()) return;
      this.downloader = true;
      this.dateDifference();
      if (this.errorMessage == "") {
        let obj = {
          start_date: this.from_date,
          end_date: this.to_date,
          client_id: this.client_name,
          origin_country: this.origin_country,
          destination_country: this.destination_country,
        };
        Object.keys(obj).forEach((key) => {
          if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
            delete obj[key];
          }
        });
        this.filtersArr = obj;
        this.trackingReport(obj)
          .then((res) => {
            this.fileDownload(res);
            this.snackBar({
              color: "success",
              message: "Data downloaded successfully",
            });
            this.downloader = false;
          })
          .catch(() => {
            this.downloader = false;
          });
      }
    },
    searchOrders() {
      if (!this.$refs.formOrder.validate()) return;
      this.downloader = true;
      if (this.destination_country) {
        this.destination_country = this.destination_country.toUpperCase();
      }
      this.dateDifference();
      if (this.errorMessage == "") {
        let obj = {
          start_date: this.from_date,
          end_date: this.to_date,
          client_id: this.client_name,
          payment_mode: this.selected_mode,
          sale_order_details_status: this.selectedStatus,
          destination_country: this.destination_country,
          sale_order_code: this.order_code,
          channel: this.channel,
        };
        Object.keys(obj).forEach((key) => {
          if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
            delete obj[key];
          }
        });
        this.filtersArr = obj;
        this.ordersReport(obj)
          .then((res) => {
            this.fileDownload(res);
            this.snackBar({
              color: "success",
              message: "Data downloaded successfully",
            });
            this.downloader = false;
          })
          .catch(() => {
            this.downloader = false;
          });
      }
    },
    clearInput(val) {
      if (val == "from_date") {
        this.from_date = "";
      } else if (val == "to_date") {
        this.to_date = "";
      } else if (val == "tracking_number") {
        this.tracking_number = "";
      } else if (val == "order_reference") {
        this.order_reference = "";
        this.order_code = "";
      }
    },
    downloadInbound() {
      if (!this.$refs.inbound.validate()) return;
      this.downloader = true;
      this.dateDifference();
      if (this.errorMessage == "") {
        let obj = {
          start_date: this.from_date,
          end_date: this.to_date,
          client_id: this.selectedClient,
          receipt_key: this.receipt_key
            ? this.receipt_key.trim()
            : this.receipt_key,
          receipt_no: this.receipt_no
            ? this.receipt_no.trim()
            : this.receipt_no,
          status: this.status,
          storer_id: this.infor_storer_id,
          warehouse_id: this.warehouse_id,
        };

        Object.keys(obj).forEach((key) => {
          if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
            delete obj[key];
          }
        });
        this.filtersArr = obj;
        this.inboundReport(obj)
          .then((res) => {
            this.fileDownload(res);
            this.snackBar({
              color: "success",
              message: "Data downloaded successfully",
            });
            this.downloader = false;
          })
          .catch(() => {
            this.downloader = false;
          });
      }
    },
    downloadOutbound() {
      if (!this.$refs.outbound.validate()) return;
      this.downloader = true;
      this.dateDifference();
      if (this.errorMessage == "") {
        let obj = {
          start_date: this.from_date,
          end_date: this.to_date,
          order_key: this.order_key ? this.order_key.trim() : this.order_key,
          client_id: this.selectedClient,
          receipt_no: this.receipt_no
            ? this.receipt_no.trim()
            : this.receipt_no,
          status: this.status,
          storer_id: this.infor_storer_id,
          warehouse_id: this.warehouse_id,
        };

        Object.keys(obj).forEach((key) => {
          if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
            delete obj[key];
          }
        });
        this.filtersArr = obj;
        this.outboundReport(obj)
          .then((res) => {
            this.fileDownload(res);
            this.snackBar({
              color: "success",
              message: "Data downloaded successfully",
            });
            this.downloader = false;
          })
          .catch(() => {
            this.downloader = false;
          });
      }
    },
    downloadPutaway() {
      if (!this.$refs.putaway.validate()) return;
      this.downloader = true;
      this.dateDifference();
      if (this.errorMessage == "") {
        let obj = {
          start_date: this.from_date,
          end_date: this.to_date,
          receipt_key: this.receipt_key
            ? this.receipt_key.trim()
            : this.receipt_key,
          external_receipt_number: this.external_receipt_number
            ? this.external_receipt_number.trim()
            : this.external_receipt_number,

          warehouse: this.warehouse_id,
        };

        Object.keys(obj).forEach((key) => {
          if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
            delete obj[key];
          }
        });
        this.filtersArr = obj;
        this.putawayreport(obj)
          .then((res) => {
            this.fileDownload(res);
            this.snackBar({
              color: "success",
              message: "Data downloaded successfully",
            });
            this.downloader = false;
          })
          .catch(() => {
            this.downloader = false;
          });
      }
    },
    searchB2B() {
      if (!this.$refs.b2b.validate()) return;
      this.downloader = true;
      this.dateDifference(92);
      if (this.errorMessage == "") {
        let obj = {
          start_date: this.from_date,
          end_date: this.to_date,
          client_id: this.client_name,
          sku_variant_code: this.sku_variant_code
            ? this.sku_variant_code.trim()
            : this.sku_variant_code,
          sku_code: this.sku_code ? this.sku_code.trim() : this.sku_code,
          sku_type: this.sku_type,
        };

        Object.keys(obj).forEach((key) => {
          if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
            delete obj[key];
          }
        });
        this.filtersArr = obj;
        this.b2bReport(obj)
          .then((res) => {
            this.fileDownload(res);
            this.snackBar({
              color: "success",
              message: "Data downloaded successfully",
            });
            this.downloader = false;
          })
          .catch(() => {
            this.downloader = false;
          });
      }
    },
    clearB2BInput() {
      this.sku_code = null;
      this.sku_variant_code = null;
      this.from_date = null;
      this.to_date = null;
    },
    downloadSla() {
      if (!this.$refs.sla.validate()) return;
      this.downloader = true;
      this.dateDifference();
      let obj = {
        start_date: this.from_date,
        end_date: this.to_date,
        client_id: this.client_name,
        carrier_id: this.carrier_id,
        status: this.sla_status,
        tracking_number: this.tracking_number_sla,
        order_reference: this.order_reference_sla,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
      this.slaReport(obj)
        .then((res) => {
          this.fileDownload(res);
          this.snackBar({
            color: "success",
            message: "Data downloaded successfully",
          });
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
  },
};
</script>

<style lang="scss">
.w-100 {
  width: 100%;
}

.padding-form {
  padding: 15px;
}

.select {
  padding-left: 20px !important;
}

.required .v-input__control {
  border-color: red;
}

.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
.pre-row {
  display: flex !important;
  padding: 5px 20px 5px 5px !important;
}
.pre-row .v-input__slot {
  min-height: 50px !important;
}
.padding-pre {
  padding-top: 30px;
}
</style>
